import { render, staticRenderFns } from "./FormSoftware.vue?vue&type=template&id=5877940c"
import script from "./FormSoftware.vue?vue&type=script&lang=js"
export * from "./FormSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports